<template>
<div>
  <div class="contentTitle row hidden-head">
    <p>占いに使用するプロフィール</p>
  </div>
  <div>

  <div class="alert" data-color="error" v-if="postParams.err_email_duplicate">入力内容に不備があります。</div>
  <section class="entryForm" v-if="postParams.free_text">
  <h1 class="entryForm__heading"><strong>ご希望の占い師</strong><br>を選択してください</h1>
  <div>
    <form-label label="鑑定を希望する占い師名" class="sub"></form-label>
    <p class="inputted_param">{{ postParams.free_text }}</p>
  </div>
  </section>

    <!-- 自分のプロフィール -->
    <section class="entryForm" v-if="showFieldSection(self) && inputEntryType !== 5 && inputEntryType !== 6">
      <div class="u-mg-t-3">
        <div
        class="u-mg-b-3"
        v-if="postParams[key] && key !== 'nonmember_email'"
        v-for="(field, key) in self"
        :data-name="key">
          <form-label :label="field.label" class="sub"></form-label>
          <p class="inputted_param" v-if="key=='relationship'" v-html="FORM_OPTIONS.relationship[postParams[key]].text"></p>
          <p class="inputted_param" v-else v-html="paramToString(key, postParams[key])"></p>
        </div>
      </div>
    </section>


    <!-- 相手のプロフィール -->
    <section class="entryForm" v-if="showFieldSection(target)">
      <div
        class="u-mg-t-3"
        v-if="postParams[key]"
        v-for="(field, key) in target"
        :data-name="key">
        <form-label :label="field.label" class="sub"></form-label>
        <p class="inputted_param" v-html="paramToString(key, postParams[key])"></p>
      </div>
    </section>

    <!-- 相手のプロフィール -->
    <section class="entryForm" v-if="showFieldSection(palm)">
      <div class="palmSideLabels">
        <div class="palmSideLabels__item">左手</div>
        <div class="palmSideLabels__item">右手</div>
      </div>
      <div class="palmInputGroup">
        <!-- 左手 -->
        <div class="palmInputGroup__item palmInput" v-if="postParams.image_url_palm_left_overall">
          <div class="palmInput__target">
            <img class="palmInput__preview" :src="postParams.storage_path + postParams.image_url_palm_left_overall">
          </div>
          <p class="palmInput__label">全体</p>
        </div>

        <div class="palmInputGroup__item palmInput" v-if="postParams.image_url_palm_left">
          <div class="palmInput__target">
            <img class="palmInput__preview" :src="postParams.storage_path + postParams.image_url_palm_left">
          </div>
          <p class="palmInput__label">拡大</p>
        </div>
        <!-- 右手 -->
        <div class="palmInputGroup__item palmInput" v-if="postParams.image_url_palm_right_overall">
          <div class="palmInput__target">
            <img class="palmInput__preview" :src="postParams.storage_path + postParams.image_url_palm_right_overall">
          </div>
          <p class="palmInput__label">全体</p>
        </div>

        <div class="palmInputGroup__item palmInput" v-if="postParams.image_url_palm_right">
          <div class="palmInput__target">
            <img class="palmInput__preview" :src="postParams.storage_path + postParams.image_url_palm_right">
          </div>
          <p class="palmInput__label">拡大</p>
        </div>
      </div>
    </section>

  </div>

  <div class="alert" data-color="error" v-if="postParams.err_email_duplicate">{{ postParams.err_email_duplicate }}</div>
  <div class="contentFooter u-mg-t-1">
    <div class="btnGroup">
      <form class="u-mg-b-2 u-mg-r-1" :action="actionBack" method="POST"
        ref="back">
        <input type="hidden" v-for="(value, key) in returnParams"
          :key="key" :name="key" :value="value">
        <button type="submit" class="btn"
          data-block="true"
          data-color="brand"
          data-stroke="true"
        >修正</button>
      </form>

      <form :action="actionComplete" method="POST" ref="submit"
        @submit.prevent="handleSubmit" v-if="!postParams.err_email_duplicate">
        <input type="hidden" v-for="(value, key) in postParams"
          :key="key" :name="key" :value="value">
          <input type="hidden" :value="movieCustomPlanningId" name="movie_custom_planning_id">
        <button type="submit" class="btn"
          data-block="true"
          data-color="brand"
          :disabled="processing">
          <span>この内容で申込む</span>
        </button>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import * as type from '@/utvStore/store/mutation-types';
import convertUserInfo from '@/utils/convertUserInfo';
import CONSTS from '@/CONSTS';
import { FORMAT, FORM_OPTIONS } from '@/CONSTS';
import dataControl from './mixins/dataControl';
import viewControl from './mixins/viewControl';
import fetchAccountData from '@/utils/fetchAccountData';

export default {
  data() {
    return {
      FORM_OPTIONS,
      processing: false
    };
  },
  name: 'entry-confirm',
  mixins: [dataControl, viewControl],
  props: {
    actionComplete: String,
    actionBack: String,
    inputEntryType: Number,
    isTextContents: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn,
      accessToken: state => state.auth.accessToken,
      card: state => state.payment.card
    })
  },
  mounted() {
    this.initializeInputData();
  },
  methods: {
    /**
     * @param {Object} obj - self|target|palm|entry  表示制御用。セクションを表示するかどうか判定
     */
    showFieldSection(obj) {
      let filterdData = Object.keys(obj).filter(key => key in this.postParams);
      // 手相の場合
      if ('palm' in obj) {
        filterdData = Object.keys(obj.palm.values).filter(key => key in this.postParams);
      }
      return Boolean(filterdData.length);
    },
    handleSubmit() {
      this.processing = true;
      this.updateProfile()
        .then(() => {
          this.$refs.submit.submit();
        })
        .catch(this.onSubmitError);
    },
    updateProfile() {
      // 未ログイン(非会員状態)の場合は何もしない
      if (!this.isLoggedIn || !this.accessToken) {
        return Promise.resolve();
      }
      /**
       * TOTO: 汎用関数化する
       */
      const data = convertUserInfo(this.postParams);
      Object.assign(data, {
        access_token: this.accessToken
      });
      Object.keys(data).forEach(key => {
        if (data[key] === '' || data[key] === undefined) {
          delete data[key];
        }
      });
      return fetchAccountData.updateProfile(data);
    },
    onSubmitError(error) {
      this.$message({
        message: '認証情報に誤りがあるため、ログアウトしました。お手数ですが再度ログインしてください。',
        type: 'error'
      });
      this.$store.dispatch(type.LOGOUT);
      throw new Error(error);
    }
  }
};
</script>

<style lang="scss" scoped>
.contentTitle {
  &.hidden-head {
    height: 0;
    overflow: hidden;
    border-top: 1px solid #d8d8d8;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/EntryConfirmLineDaily.vue